export default "__VITE_ASSET__tfezFxNL__"